import React, { useRef } from 'react';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import styled from '@emotion/styled';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
import { useMegaMenu } from './MegaMenuContext';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { hoverGracePeriod, secondaryNavigationId } from './MegaMenu.config';
import useMediaQuery from '@polestar/component-warehouse-react/hooks/useMediaQuery';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
import { TextButton } from '@polestar/component-warehouse-react/components/button/Button';
import { labelTextStyle, linkStyle } from './MegaMenu.styles';
import { css } from '@emotion/react';
import useTrackingData, { formatTrackingLabel, } from '@polestar/component-warehouse-react/hooks/useTrackingData';
import { DataLayerAction, DataLayerCategory, DataLayerEvent, } from '@polestar/component-warehouse-react/tokens/analytics/Analytics';
import { focusProviderOptions } from '@polestar/component-warehouse-react/contexts/focus';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
export const MegaMenuMultiPurposeLink = ({ link: { href, label, eventLabel, 'aria-label': ariaLabel, ...linkProps }, hasDeepLinks, navigationIndex, megaMenuId, isFirst = false, isLast = false, onMouseEnter, onMouseLeave, ...props }) => {
    // TODO: ignored for now
    href;
    linkProps;
    const { setFlyoutActive, setActiveFlyoutIndex, activeFlyoutIndex, setRestoreElement, flyoutItems, setFlyoutHasFocus, } = useMegaMenu();
    {
        /* todo: keep for links
      const onChevronClick = (event, index: number) => {
        if (index !== activeFlyoutIndex) {
          setFlyoutActive(true);
          setActiveFlyoutIndex(index);
        } else {
          setFlyoutActive(false);
          setActiveFlyoutIndex(null);
        }
      };
    
      const onLinkKeyDown = (event: KeyboardEvent, index) => {
        // console.log(index);
        if (event.key === 'Tab' && event.shiftKey && activeFlyoutIndex === index - 1) {
          event.preventDefault();
          setFlyoutHasFocus(true);
          flyoutItems[index - 1][flyoutItems[index - 1].length - 1].focus();
        }
      };
    
      const onChevronKeyDown = (event: KeyboardEvent, index: number) => {
        if (index === activeFlyoutIndex && event.key === 'Tab' && !event.shiftKey) {
          event.preventDefault();
          setRestoreElement(event.currentTarget);
          flyoutItems[index][0].focus();
          setFlyoutHasFocus(true);
          return;
        }
    
        setRestoreElement(null);
      };
    
      const onLinkMouseEnter = (navigationIndex: number) => {
        if (hasDeepLinks && navigationIndex !== undefined) {
          setFlyoutActive(true);
          setActiveFlyoutIndex(navigationIndex);
        }
      };
      */
    }
    const { name } = useMediaQuery();
    const respondOnEnter = name === DeviceTypes.desktop || name === DeviceTypes.desktopWide;
    const hoverTimeoutRef = useRef(null);
    const onTextButtonEnter = (navigationIndex) => {
        if (respondOnEnter && hasDeepLinks && navigationIndex !== undefined) {
            setFlyoutActive(true);
            setActiveFlyoutIndex(navigationIndex);
        }
    };
    const onTextButtonClick = (event, navigationIndex) => {
        setRestoreElement(event.currentTarget);
        if (hasDeepLinks && navigationIndex !== undefined) {
            setFlyoutActive(true);
            setActiveFlyoutIndex(navigationIndex);
        }
        trackingLinkClick();
    };
    const onTextButtonKeyDown = (event, navigationIndex) => {
        if (event.key === 'Tab' && !event.shiftKey) {
            if (navigationIndex === activeFlyoutIndex) {
                event.preventDefault();
                flyoutItems[navigationIndex][0].focus();
                setFlyoutHasFocus(true);
                return;
            }
            if (isLast) {
                setFlyoutActive(false);
                setActiveFlyoutIndex(null);
                setFlyoutHasFocus(false);
                return;
            }
        }
        if (event.key === 'Tab' && event.shiftKey) {
            if (isFirst) {
                setFlyoutActive(false);
                setActiveFlyoutIndex(null);
                return;
            }
            const previousIndex = navigationIndex - 1;
            if (previousIndex === activeFlyoutIndex) {
                event.preventDefault();
                flyoutItems[previousIndex][flyoutItems[previousIndex].length - 1].focus();
                return;
            }
        }
    };
    // tracking
    const { pushDataLayer } = useTrackingData();
    const trackingLinkClick = () => {
        pushDataLayer({
            event: DataLayerEvent.LINK_CLICK,
            category: DataLayerCategory.MENU,
            action: DataLayerAction.CATEGORY_CLICK,
            // TODO: en naming, how?
            label: formatTrackingLabel(eventLabel),
        });
    };
    const handleHover = () => {
        trackingLinkClick();
        onTextButtonEnter(navigationIndex);
    };
    const handleMouseEnter = (event) => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        hoverTimeoutRef.current = setTimeout(() => {
            handleHover();
            onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(event);
        }, hoverGracePeriod);
    };
    const handleMouseLeave = (event) => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
            onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event);
        }
    };
    const handleClick = (event) => onTextButtonClick(event, navigationIndex);
    const handleKeyDown = (event) => onTextButtonKeyDown(event, navigationIndex);
    return (React.createElement(LinkWrapper, null,
        React.createElement(StyledTextButton, { id: `${megaMenuId}-${secondaryNavigationId}-control-${navigationIndex}`, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleClick, onKeyDown: handleKeyDown, ...props, ...aria({
                expanded: activeFlyoutIndex === navigationIndex,
                controls: `${megaMenuId}-${secondaryNavigationId}-${navigationIndex}`,
                label: ariaLabel,
                // selected: activeFlyoutIndex === navigationIndex, TODO: should tabs be used?
            }), ...focusProviderOptions({
                /* Removes the additional spacing of the focus ring */
                spacing: 0,
            }) }, label)));
};
const LinkWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: ${Spacings.xxSmall};

  ${MediaQueries.untilDesktop} {
    overflow-x: hidden;
  }
  ${MediaQueries.desktop} {
    padding: 0;
  }

  > * {
    flex-shrink: 0;
  }
`;
// const ChevronButton = styled.button<{ isRTL?: boolean }>`
//   position: absolute;
//   inset: 0;
//   border: none;
//   border-radius: 0;
//   background: none;
//   background: currentColor;
//   cursor: pointer;
//   opacity: 0;
//   ${MediaQueries.desktop} {
//     inset: 50% 0 auto auto;
//     translate: calc(100% + ${createCustomSpacing(5 / 16)}) -50%;
//     inline-size: ${createCustomSpacing(10 / 16)};
//     aspect-ratio: 1;
//     pointer-events: none;
//     &:focus-within,
//     &:focus-visible {
//       opacity: 1;
//     }
//   }
// `;
// const StyledLink = styled(Link)`
//   ${linkStyle};
//   ${MediaQueries.desktop} {
//     ${labelTextStyle}
//   }
// `;
const StyledTextButton = styled(TextButton)(({ theme }) => css `
    ${linkStyle};
    padding-block: ${createCustomSpacing(5 / 16)};
    overflow: hidden;

    &:hover:not(:disabled) {
      color: ${theme.megaMenu.color};
    }

    ${MediaQueries.untilDesktop} {
      padding-block: ${createCustomSpacing(3 / 16)};

      /* remove ellipsis (adjust spans) */
      span {
        height: auto;

        span {
          text-overflow: unset;
          overflow: unset;
          line-height: ${LineHeights.large};
          white-space: normal;
          /* ensure correct rendering of very long text */
          overflow-wrap: break-word;
        }
      }
    }
    ${MediaQueries.desktop} {
      ${labelTextStyle};
      padding-block: ${createCustomSpacing(4 / 16)} ${createCustomSpacing(2 / 16)};

      max-width: 25vw;

      > * {
        height: 1.125em !important;
      }
    }

    ${MediaQueries.desktopWide} {
      max-width: 20vw;
    }
  `);
